/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
import axios from 'axios';
import { PROJECT_REGISTRATION_FORM } from '../mutation-types';
import projectRegistrationApi from '../../services/api/projectRegistration.api';
import { setState } from '../mutationHelpers';
import { ProjectRegistrationStorePayload } from '../../models';

const namespaced = true;

const state = {
  formFields: {
    id: null,
    projectName: '',
    projectCity: '',
    projectCountry: '',
    projectStateProvince: '',
    projectStandards: 'AWI Standards, Current Edition',
    projectStatus: '',
    projectCompletionDate: null,
    projectEstimatedShopDrawingStart: null,
    projectBidDate: null,
    submitterName: '',
    submitterEmail: '',
    submitterProjectRole: '',
    firmName: '',
    firmContactFirstName: '',
    firmContactLastName: '',
    firmEmail: '',
    firmAddressLine1: '',
    firmAddressLine2: '',
    firmCity: '',
    firmCountry: '',
    firmStateProvince: '',
    firmZip: '',
    firmPhone: '',
    firmFax: '',
    sendCredentialsToDesignFirm: false,
    showContractorInfo: null,
    contractorName: '',
    contractorFirstName: '',
    contractorLastName: '',
    contractorEmail: '',
    contractorAddressLine1: '',
    contractorAddressLine2: '',
    contractorCity: '',
    contractorCountry: '',
    contractorStateProvince: '',
    contractorZip: '',
    contractorPhone: '',
    contractorFax: '',
    sendCredentialsToContractor: false,
    showWoodworkerInfo: null,
    woodworkerName: '',
    woodworkerContactFirstName: '',
    woodworkerContactLastName: '',
    woodworkerEmail: '',
    woodworkerAddressLine1: '',
    woodworkerAddressLine2: '',
    woodworkerCity: '',
    woodworkerCountry: '',
    woodworkerStateProvince: '',
    woodworkerZip: '',
    woodworkerPhone: '',
    woodworkerFax: '',
    sendCredentialsToWoodworker: false,
    woodworkerId: 0,
    contractorContactId: 0,
    contractorId: 0,
    firmContactId: 0,
    firmId: 0,
    projectInfoId: 0,
  } as ProjectRegistrationStorePayload,
  currentPage: 1,
  countryOptions: [],
  submitting: false,
  submitted: false,
};

const getters = {
  countryOptions: storeState => storeState.countryOptions,
  stateProvinceOptions: storeState => countryName => (storeState.countryOptions.find(x => x.name === countryName) ? storeState.countryOptions.find(x => x.name === countryName).stateProvinces : []),
  formFields: storeState => storeState.formFields,
  currentPage: storeState => storeState.currentPage,
  submitting: storeState => storeState.submitting,
  submitted: storeState => storeState.submitted,
};

const mutations = {
  [PROJECT_REGISTRATION_FORM.UPDATE_COUNTRY_OPTIONS]: setState('countryOptions'),
  [PROJECT_REGISTRATION_FORM.CHANGE_CURRENT_PAGE]: setState('currentPage'),
  [PROJECT_REGISTRATION_FORM.TOGGLE_SUBMITTED_STATE]: setState('submitted'),
  [PROJECT_REGISTRATION_FORM.TOGGLE_SUBMITTING_STATE]: setState('submitting'),

  [PROJECT_REGISTRATION_FORM.FORM_FIELDS](formState, fields) {
    Object.assign(formState.formFields, fields);
  },
};

const actions = {
  existingInfoFieldUpdate({ commit }, payload) {
    commit(PROJECT_REGISTRATION_FORM.FORM_FIELDS, payload);
  },

  async stepThreeNextPage({ dispatch, commit, state: actionState }) {
    const formFields = actionState.formFields as ProjectRegistrationStorePayload;
    if (formFields.showContractorInfo) {
      commit(PROJECT_REGISTRATION_FORM.CHANGE_CURRENT_PAGE, 4);
      await dispatch('saveStep');
    } else if (formFields.showWoodworkerInfo) {
      commit(PROJECT_REGISTRATION_FORM.CHANGE_CURRENT_PAGE, 5);
      await dispatch('saveStep');
    } else {
      await dispatch('submitForm');
    }
    window.scrollTo(0, 0);
  },

  async stepFourNextPage({ dispatch, commit, state: actionState }) {
    const formFields = actionState.formFields as ProjectRegistrationStorePayload;
    if (formFields.showWoodworkerInfo) {
      commit(PROJECT_REGISTRATION_FORM.CHANGE_CURRENT_PAGE, 5);
      await dispatch('saveStep');
    } else {
      await dispatch('submitForm');
    }
    window.scrollTo(0, 0);
  },

  async goToNextPage({ dispatch, commit, state: actionState }) {
    commit(PROJECT_REGISTRATION_FORM.CHANGE_CURRENT_PAGE, actionState.currentPage + 1);
    await dispatch('saveStep');
    window.scrollTo(0, 0);
  },

  stepFiveBackPage({ dispatch, commit, state: actionState }) {
    const formFields = actionState.formFields as ProjectRegistrationStorePayload;
    if (formFields.showContractorInfo) {
      commit(PROJECT_REGISTRATION_FORM.CHANGE_CURRENT_PAGE, 4);
    } else {
      commit(PROJECT_REGISTRATION_FORM.CHANGE_CURRENT_PAGE, 3);
    }
    window.scrollTo(0, 0);
  },

  goToPrevPage({ commit, state: actionState }) {
    commit(PROJECT_REGISTRATION_FORM.CHANGE_CURRENT_PAGE, actionState.currentPage - 1);
    window.scrollTo(0, 0);
  },

  async getCountries({ commit }) {
    const { data } = await axios.get('/api/countries');
    commit(PROJECT_REGISTRATION_FORM.UPDATE_COUNTRY_OPTIONS, data);
  },

  saveStep({ commit, state: actionState }) {
    return new Promise(async (resolve, reject) => {
      const formFields = actionState.formFields as ProjectRegistrationStorePayload;
      try {
      if (formFields.id) {
        await projectRegistrationApi.update(formFields.id, formFields);
      } else {
        const { data } = await projectRegistrationApi.create(formFields);
        commit(PROJECT_REGISTRATION_FORM.FORM_FIELDS, data);
      }
      resolve();
    } catch (error) {
      reject(error);
    }
    });
  },

  submitForm({ commit, state: actionState }) {
    return new Promise(async (resolve, reject) => {
      commit(PROJECT_REGISTRATION_FORM.TOGGLE_SUBMITTING_STATE, true);
      const formFields = actionState.formFields as ProjectRegistrationStorePayload;
      try {
        await projectRegistrationApi.submitFinal(formFields.id, formFields);
        commit(PROJECT_REGISTRATION_FORM.TOGGLE_SUBMITTED_STATE, true);
        try {
          // eslint-disable-next-line @typescript-eslint/no-angle-bracket-type-assertion
          (<any>window).gtag('config', 'UA-69171335-1', {
            page_title: 'Register a Project - Submitted',
            page_path: '/forms/register-project/submitted',
          });
        } catch (error) {}

        try {
          (window as any).lintrk('track', { conversion_id: 8733873 });
        } catch (error) {}
        resolve();
      } catch (error) {
        commit(PROJECT_REGISTRATION_FORM.TOGGLE_SUBMITTING_STATE, false);
        reject(error);
      }
    });
  },
};

export default ({
  namespaced,
  state,
  getters,
  actions,
  mutations,
});